import { Card } from "antd";
import { UsergroupAddOutlined, UserAddOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PersonaFinepModal } from "../PersonaFinepModal";
import "./styles.css";
interface PersonaCompanyCreateCardProps {
    type: "Natural" | "Legal";
    getPersons: () => Promise<void>;
}

export const PersonaCompanyCreateCard = ({
    type,
    getPersons,
}: PersonaCompanyCreateCardProps) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const navigate = useNavigate();
    const { id, registerId } = useParams();
    const goToCompanyTabs = () => navigate(`/companyFinep/${registerId}/${id}`);

    return (
        <>
            <Card
                hoverable
                className="physical-legal-card"
                onClick={type === "Natural" ? handleOpen : goToCompanyTabs}
            >
                <div className="icon-container">
                    {type === "Natural" ? (
                        <UserAddOutlined className="icon-style" />
                    ) : (
                        <UsergroupAddOutlined className="icon-style" />
                    )}
                </div>
                <span className="card-title">
                    {type === "Natural" ? "Nova Pessoa Física" : "Nova Pessoa Jurídica"}
                </span>
            </Card>

            <PersonaFinepModal getPersons={getPersons} show={open} handleClose={handleClose} />
        </>
    );
};